import { CheckInForm } from '../components/CheckInForm';
import { InstagramPanel } from '../components/InstagramPanel';
import { useDocumentMeta } from '../lib/seo';

export function CheckIn() {
  useDocumentMeta(
    'Join the Walk-In List | Nine80 Hair Studio',
    'Add yourself to the Nine80 Hair Studio walk-in list in under a minute.',
  );

  return (
    <div className="mx-auto max-w-6xl px-4 py-10">
      <div className="grid gap-10 lg:grid-cols-[minmax(0,480px)_1fr] lg:items-start">
        {/* Form first in DOM order so it's usable immediately on mobile without
            scrolling past marketing content (spec §35/§46). */}
        <div>
          <h1 className="text-3xl sm:text-4xl mb-6">Join the Walk-In List</h1>
          <CheckInForm source="WEB" />
        </div>
        <div className="hidden lg:block">
          <InstagramPanel compact />
        </div>
      </div>
    </div>
  );
}
